import React from 'react'
import './Footer.css'

export default () => (
  <div>
    <footer className="footer">
      <div className="container taCenter">
        <span>
         Capital Area Research LLC © Copyright {new Date().getFullYear()} All rights reserved.<br/>
         875 Popular Church Rd. Suite 330 Camp Hill, PA - 717.963.8389
        </span>
      </div>
    </footer>
  </div>
)
